import PropTypes from 'prop-types'
import React from 'react'

import { SearchBar } from '../../search'
import { trackSearchInitiatedFromCMSPage } from '../../tracking'

export const CmsSearchBar = ({ title }) => {
  return (
    <section className='cms-section cms-section--search-bar'>
      <div className='container cms-block__container '>
        <div className='row'>
          <div className='col text-center'>
            <h2 className='mb-3'>{title}</h2>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <SearchBar onSubmitAction={trackSearchInitiatedFromCMSPage} />
          </div>
        </div>
      </div>
    </section>
  )
}

CmsSearchBar.propTypes = {
  title: PropTypes.string.isRequired
}

export default CmsSearchBar
